// general purpose async fetching

async function attemptFetch(scope, url, options = { method: 'get' }, attempts = 3, status = {}) {
  if (attempts === 0) {
    console.error(`Error fetching data (${scope}): `, status.code, status.text);
    return false;
  }
  const promise = await fetch(url, options);
  if (!promise.ok)
    return await attemptFetch(scope, url, options, attempts - 1, {
      code: promise.status,
      text: promise.statusText,
      promise: promise,
    });
  return promise;
}

// product quantity input

function initQuantityInput(container, callback) {
  const controls = container.querySelectorAll('[data-controls]');
  const label = container.querySelector('[data-value]');
  const min = container.dataset.hasOwnProperty('min') ? parseInt(container.dataset.min) : false;
  const max = container.dataset.hasOwnProperty('max') ? parseInt(container.dataset.max) : false;
  const addControl = container.querySelector('[data-controls="add"]');
  controls.forEach((trigger) => {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      const value = parseInt(container.dataset.quantity);
      if (trigger.dataset.controls === 'add' && value === max) return;
      const result = getInputResult(trigger.dataset.controls, value, min, max);
      addControl.disabled = result === max;
      if (label) {
        label.dataset.value = result;
        label.textContent = result;
      }
      container.dataset.quantity = result;
      callback(container, result);
    });
  });
}

function getInputResult(operation, value, min = 0, max = false) {
  const result = operation === 'add' ? value + 1 : value - 1;
  if (min !== false && result < min) return min;
  if (max !== false && result > max) return max;
  return result;
}
